import { endViewAsMutation, issueViewAsTokenMutation, listViewAsOptions } from "@payezy/api-client/admin/query";
import { Badge, Button, Card, EmptyState, formatDate, humanize, PageHeader, shortId, Table, Tabs, TD, TH, THead, TR, toast } from "@payezy/ui";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { showError } from "../lib/notify";
import { useStaff } from "../lib/staff";

export function ViewAsPage() {
  const me = useStaff();
  const qc = useQueryClient();
  const [tab, setTab] = useState("active");
  const q = useQuery({
    ...listViewAsOptions({ query: { status: tab === "active" ? "active" : undefined, mine: tab === "mine" ? true : undefined, limit: 200 } }),
    placeholderData: keepPreviousData,
    refetchInterval: 30_000,
  });
  const open = useMutation({ ...issueViewAsTokenMutation(), onSuccess: (g) => window.open(g.url, "_blank", "noopener,noreferrer"), onError: showError });
  const end = useMutation({
    ...endViewAsMutation(),
    onSuccess: () => {
      toast.success("Session ended.");
      void qc.invalidateQueries();
    },
    onError: showError,
  });
  const items = q.data?.items ?? [];
  return (
    <>
      <PageHeader title="View-as sessions" description="Staff sessions in the customer app. Start one from a customer's page. Sessions expire automatically; ending one signs the tab out immediately." />
      <Tabs value={tab} onValueChange={setTab} tabs={[{ value: "active", label: "Active" }, { value: "mine", label: "Mine" }, { value: "all", label: "All" }]} />
      <Card>
        <Table>
          <THead><TR><TH>Started</TH><TH>Staff</TH><TH>Customer</TH><TH>Scope</TH><TH>Reason</TH><TH>Status</TH><TH /></TR></THead>
          <tbody>
            {items.map((v) => {
              const live = v.status === "active" && new Date(v.expires_at) > new Date();
              return (
                <TR key={v.id}>
                  <TD>{formatDate(v.created_at, true)}</TD>
                  <TD>{v.staff_email ?? shortId(v.staff_id)}</TD>
                  <TD><Link to="/customers/$orgId" params={{ orgId: v.org_id }} className="font-mono text-xs hover:underline">{shortId(v.org_id)}</Link></TD>
                  <TD><Badge tone={v.scope === "write" ? "danger" : "info"}>{v.scope}</Badge></TD>
                  <TD className="max-w-72"><p className="line-clamp-2 text-sm" title={v.reason}>{v.reason}</p></TD>
                  <TD>{live ? `until ${formatDate(v.expires_at, true)}` : humanize(v.status)}</TD>
                  <TD className="whitespace-nowrap text-right">
                    {live && v.staff_id === me.id && (
                      <Button size="sm" variant="secondary" className="mr-2" onClick={() => open.mutate({ path: { sessionId: v.id } })}>Open</Button>
                    )}
                    {live && (v.staff_id === me.id || me.can("staff:manage")) && (
                      <Button size="sm" variant="danger" loading={end.isPending} onClick={() => end.mutate({ path: { sessionId: v.id } })}>End</Button>
                    )}
                  </TD>
                </TR>
              );
            })}
          </tbody>
        </Table>
        {!q.isLoading && items.length === 0 && <EmptyState title="No sessions" />}
      </Card>
    </>
  );
}
